import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07e8cb8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter p-1 px-md-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary text-left" }, "Filter by", -1))
const _hoisted_3 = { class: "d-flex flex-wrap mb-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "d-lg-block d-md-flex flex-wrap"
}
const _hoisted_6 = { class: "mb-3 mx-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase fw-light mb-2" }, "program areas", -1))
const _hoisted_8 = { class: "text-primary" }
const _hoisted_9 = { class: "mb-3 mx-md-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase fw-light mb-2" }, "districts", -1))
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "mb-3 mx-md-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase fw-light mb-2" }, "health system areas", -1))
const _hoisted_15 = { class: "text-primary" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCheckBox = _resolveComponent("BaseCheckBox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterAreas, (filter, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: index,
          onClick: ($event: any) => (_ctx.passTag(filter)),
          class: _normalizeClass([[filter === _ctx.activeTab ? 'btn-primary text-white' : ''], "rounded-1 py-1 mx-1 btn btn-outline-primary mb-2"])
        }, _toDisplayString(filter), 11, _hoisted_4))
      }), 128))
    ]),
    (_ctx.check)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("section", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("small", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programAreaCheckBox, (box) => {
                return (_openBlock(), _createBlock(_component_BaseCheckBox, {
                  key: box.id,
                  inputType: box
                }, null, 8, ["inputType"]))
              }), 128)),
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("See 5 more")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("section", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("small", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districtsCheckBox, (box) => {
                return (_openBlock(), _createBlock(_component_BaseCheckBox, {
                  key: box.id,
                  inputType: box
                }, null, 8, ["inputType"]))
              }), 128)),
              _hoisted_12,
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("See 14 more")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("section", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("small", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.healthSystemAreaCheckBox, (box) => {
                return (_openBlock(), _createBlock(_component_BaseCheckBox, {
                  key: box.id,
                  inputType: box
                }, null, 8, ["inputType"]))
              }), 128)),
              _hoisted_16,
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("See 4 more")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}